import { SelectOption } from '@/components/elements/select'
import { Entities } from '@/entities/api/entities'
import flavorMap from '@/entities/api/products/flavors'
import colorsMap from '@/entities/api/products/colors'
import sizeMap from '@/entities/api/products/size'
import modalitiesMap from '@/entities/api/products/modalities'
import objectivesMap from '@/entities/api/products/objectives'
import { NameAttributes } from '@/entities/api/products/name-attributes'

export const attributesMap = (type: Entities): SelectOption[] => {
	const map: SelectOption[] = []

	if (type === Entities.SUPPLEMENTS) {
		for (const flavor in flavorMap) {
			if (flavorMap.hasOwnProperty(flavor)) {
				map.push({
					label: flavor,
					value: flavorMap[flavor as keyof typeof flavorMap] || '',
					type: NameAttributes.FLAVOR,
				})
			}
		}
	}

	if (type === Entities.ACCESSORIES || type === Entities.CLOTHES) {
		for (const size in sizeMap) {
			if (sizeMap.hasOwnProperty(size)) {
				map.push({
					label: size,
					value: sizeMap[size as keyof typeof sizeMap] || '',
					type: NameAttributes.SIZE,
				})
			}
		}

		for (const color in colorsMap) {
			if (colorsMap.hasOwnProperty(color)) {
				map.push({
					label: color,
					value: colorsMap[color as keyof typeof colorsMap] || '',
					type: NameAttributes.COLOR,
				})
			}
		}
	}

	if (type === Entities.PLANS_PERSONALIZED) {
		for (const modality in modalitiesMap) {
			if (modalitiesMap.hasOwnProperty(modality)) {
				map.push({
					label: modality,
					value: modalitiesMap[modality as keyof typeof modalitiesMap] || '',
					type: NameAttributes.MODALITY,
				})
			}
		}

		for (const objective in objectivesMap) {
			if (objectivesMap.hasOwnProperty(objective)) {
				map.push({
					label: objective,
					value: objectivesMap[objective as keyof typeof objectivesMap] || '',
					type: NameAttributes.OBJECTIVE,
				})
			}
		}
	}

	return map
}
